export default `
  query getAllAttributes($filter: ProductAttributeFilterInput) {
    products(filter: $filter) {
      aggregations {
        attribute_code
      }
    }
  }
`;
